var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{style:(_vm.defaultStyle),attrs:{"layout":"prev,pager,next","small":_vm.small,"background":_vm.background,"current-page":_vm.page,"page-size":_vm.pageSize,"total":_vm.total,"hide-on-single-page":true},on:{"current-change":_vm.changePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }